import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    LinearProgress,
    TextField,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { PointDialogStates } from '../../../constants';

const DEFAULT_POINT = {
    nombre: '',
    latitud: '',
    longitud: '',
    cliente: '',
    zona: '',
    sat: '',
    correos: '',
};

const PointDialog = ({ close, createPoint, editPoint, loading, point: initialPoint, state }) => {
    const [point, setPoint] = useState(DEFAULT_POINT);
    const auth = useSelector((state) => state.auth);
    /**
     * To load the points 
     */
    useEffect(() => {
        if (initialPoint) {
            setPoint(initialPoint);
        }
    }, [initialPoint]);


    /**
     * To load the points to be edited 
     */
    useEffect(() => {
        if (state === PointDialogStates.CLOSED) {
            setPoint(DEFAULT_POINT);
        }
    }, [state]);

    /**
     * To create / change the points 
     * @param {Event} event 
     */
    const handleChange = (event) => {
        setPoint((previousPoint) => ({ ...previousPoint, [event.target.name]: event.target.value }));
    };

    return (
        <Dialog onClose={close} open={state !== PointDialogStates.CLOSED}>
            <DialogTitle>
                {state === PointDialogStates.CREATION && 'Crear TWS'}
                {state === PointDialogStates.EDITION && 'Editar TWS'}
            </DialogTitle>
            <DialogContent>
                {loading && <LinearProgress />}
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            label="Nombre TWS"
                            name="nombre"
                            onChange={handleChange}
                            required
                            value={point.nombre}
                        />
                    </Grid>
                    {auth.valitadion.crudCompleto === 'True' && 
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            inputProps={{ step: 'any' }}
                            label="Latitud"
                            name="latitud"
                            onChange={handleChange}
                            required
                            type="number"
                            value={point.latitud}
                        />
                    </Grid>
                    }
                    {auth.valitadion.crudCompleto === 'True' &&
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            inputProps={{ step: 'any' }}
                            label="Longitud"
                            name="longitud"
                            onChange={handleChange}
                            required
                            type="number"
                            value={point.longitud}
                        />
                    </Grid>
                    }
                    {auth.valitadion.crudCompleto === 'Parcial' && 
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            inputProps={{ step: 'any' }}
                            label="Latitud"
                            name="latitud"
                            onChange={handleChange}
                            required
                            type="number"
                            value={point.latitud}
                        />
                    </Grid>
                    }
                    {auth.valitadion.crudCompleto === 'Parcial' &&
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            inputProps={{ step: 'any' }}
                            label="Longitud"
                            name="longitud"
                            onChange={handleChange}
                            required
                            type="number"
                            value={point.longitud}
                        />
                    </Grid>
                    }     

                    {auth.valitadion.crudCompleto === 'ParcialC' && 
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            inputProps={{ step: 'any' }}
                            label="Latitud"
                            name="latitud"
                            onChange={handleChange}
                            required
                            type="number"
                            value={point.latitud}
                        />
                    </Grid>
                    }
                    {auth.valitadion.crudCompleto === 'ParcialC' &&
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            inputProps={{ step: 'any' }}
                            label="Longitud"
                            name="longitud"
                            onChange={handleChange}
                            required
                            type="number"
                            value={point.longitud}
                        />
                    </Grid>
                    }                       

                    {auth.valitadion.crudCompleto === 'Medio' && 
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            inputProps={{ step: 'any' }}
                            label="Latitud"
                            name="latitud"
                            onChange={handleChange}
                            required
                            type="number"
                            value={point.latitud}
                        />
                    </Grid>
                    }
                    {auth.valitadion.crudCompleto === 'Medio' &&
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            inputProps={{ step: 'any' }}
                            label="Longitud"
                            name="longitud"
                            onChange={handleChange}
                            required
                            type="number"
                            value={point.longitud}
                        />
                    </Grid>
                    }          

                    {auth.valitadion.crudCompleto === 'True' &&
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            label="Cliente"
                            name="cliente"
                            onChange={handleChange}
                            required
                            value={point.cliente}
                        />
                    </Grid>
                    }
                    {auth.valitadion.crudCompleto === 'True' &&
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            label="Zona"
                            name="zona"
                            onChange={handleChange}
                            required
                            value={point.zona}
                        />
                    </Grid>
                    }
                    {auth.valitadion.crudCompleto === 'True' &&
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            label="SAT"
                            name="sat"
                            onChange={handleChange}
                            required
                            value={point.sat}
                        />
                    </Grid>
                    }
                    {auth.valitadion.crudCompleto === 'True' &&               
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            name="correos"
                            onChange={handleChange}
                            required
                            value={point.correos}
                            multiline
                            rows={4}
                            label="E-mail Ingresar las cuentas de e-mail separadas por , Y sin espacios"
                        />
                    </Grid>
                    }
                    {auth.valitadion.crudCompleto === 'False' &&               
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            name="correos"
                            onChange={handleChange}
                            required
                            value={point.correos}
                            multiline
                            rows={6}
                            label="E-mail Ingresar las cuentas de e-mail separadas por , Y sin espacios"
                        />
                    </Grid>
                    }      
                    {auth.valitadion.crudCompleto === 'Medio' &&               
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            name="correos"
                            onChange={handleChange}
                            required
                            value={point.correos}
                            multiline
                            rows={6}
                            label="E-mail Ingresar las cuentas de e-mail separadas por , Y sin espacios"
                        />
                    </Grid> 
                    }       
                    {auth.valitadion.crudCompleto === 'ParcialC' &&               
                    <Grid item xs={12}>
                        <TextField
                            disabled={loading}
                            fullWidth
                            name="correos"
                            onChange={handleChange}
                            required
                            value={point.correos}
                            multiline
                            rows={6}
                            label="E-mail Ingresar las cuentas de e-mail separadas por , Y sin espacios"
                        />
                    </Grid> 
                    }                                               
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button color="primary" disabled={loading} onClick={close}>
                    Cancelar
                </Button>
                {state === PointDialogStates.CREATION && (
                    <Button color="primary" disabled={loading} onClick={() => createPoint(point)}>
                        Crear
                    </Button>
                )}
                {state === PointDialogStates.EDITION && (
                    <Button color="primary" disabled={loading} onClick={() => editPoint(point)}>
                        Editar
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

PointDialog.propTypes = {
    close: PropTypes.func,
    createPoint: PropTypes.func,
    editPoint: PropTypes.func,
    loading: PropTypes.bool,
    point: PropTypes.object,
    visible: PropTypes.bool,
};

export default PointDialog;
